import React, { FC } from 'react'

import styles from './paymentSuccessBanner.module.scss'

interface PaymentSuccessBannerProps {
  onClose: () => void
}

export const PaymentSuccessBanner: FC<PaymentSuccessBannerProps> = ({
  onClose,
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <svg
            fill="none"
            height={22}
            viewBox="0 0 24 24"
            width={22}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 6 9 17l-5-5"
              stroke="#1FAE63"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
            />
          </svg>
        </div>
        <div className={styles.textContent}>
          <div className={styles.title}>Payment Successful</div>
          <div className={styles.message}>
            Your subscription has been renewed successfully. The data processing
            will begin shortly.
          </div>
        </div>
      </div>
      <button
        aria-label="Dismiss"
        className={styles.closeButton}
        onClick={onClose}
        type="button"
      >
        ×
      </button>
    </div>
  )
}
